import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';

/**
 * Simple modal dialog component for styling and click-trap
 * Host component controls visibility and content
 *
 * Usage:
 * @if (showDialog()) {
 *   <app-modal-dialog (backdropClick)="showDialog.set(false)">
 *     <div header>Title Here</div>
 *     <div content>Body content here</div>
 *     <div footer>
 *       <app-button (click)="handleAction()">Confirm</app-button>
 *       <app-button variant="text" (click)="showDialog.set(false)">Cancel</app-button>
 *     </div>
 *   </app-modal-dialog>
 * }
 */
@Component({
  selector: 'app-modal-dialog',
  standalone: true,
  imports: [ClickOutsideDirective],
  templateUrl: './modal-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./modal-dialog.component.css', '../../../../css/modal-base.css'],
})
export class ModalDialogComponent {
  @Output() backdropClick = new EventEmitter<void>();
}
